import styled from "@emotion/styled";
import { IStyledComponentProps } from "../../theme/theme.types";

export const StreetlightIcon = styled.svg<IStyledComponentProps>`
  &.streetlight-icon {
    .light {
      fill: none;
      stroke-linecap: round;
      stroke-width: 12.785px;
    }
  }
`;

export default { StreetlightIcon };
